
import { Link } from 'react-router-dom';

const CTASection = () => {
  return (
    <section className="relative py-32 overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/caf93251b0ce2766a7e998d0c0f2cd62.jpg"
          alt="Bay Area Skyline"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/40 to-black/50"></div>
      </div>

      <div className="relative z-10 max-w-[1400px] mx-auto px-6 lg:px-12 text-center">
        <h2 className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-bold text-white mb-6 uppercase leading-tight">
          READY TO SECURE YOUR PROPERTY?
        </h2>
        <p className="text-base sm:text-lg md:text-xl text-gray-200 mb-12 max-w-3xl mx-auto leading-relaxed">
          Get a free consultation and custom security assessment from our certified technicians
        </p>
        <Link
          to="/contact"
          className="inline-flex items-center gap-3 sm:gap-4 bg-black text-white px-6 sm:px-10 py-4 sm:py-5 rounded-full font-medium text-base sm:text-lg hover:bg-gray-900 transition-all group cursor-pointer whitespace-nowrap"
        >
          <div className="w-10 h-10 sm:w-12 sm:h-12 rounded-full bg-primary flex items-center justify-center">
            <i className="ri-phone-line text-white text-lg sm:text-xl"></i>
          </div>
          <span>SCHEDULE CONSULTATION</span>
          <i className="ri-arrow-right-up-line text-lg sm:text-xl group-hover:translate-x-1 group-hover:-translate-y-1 transition-transform"></i>
        </Link>
      </div>
    </section>
  );
};

export default CTASection;
